import React, { type FC, useMemo } from 'react';
import clsx from 'clsx';
import { isEmpty } from 'lodash-es';
import { FlexBox } from '@is24at/react-ui-core';
import { getAwardsByActiveFeatures, type Award } from './Awards';
import styles from './Awards.scss';

type AwardLabelProps = {
  award: Award;
};

export const AwardLabel: FC<AwardLabelProps> = ({
  award: { className, LabelComponent },
}) => (
  <div className={clsx(styles[`award-label__${className}`])}>
    {LabelComponent}
  </div>
);

type AwardLabelsProps = {
  activeFeatures: string[];
};

export const AwardLabels: FC<AwardLabelsProps> = ({ activeFeatures }) => {
  const awards = useMemo(
    () => getAwardsByActiveFeatures(activeFeatures),
    [activeFeatures],
  );

  if (isEmpty(awards)) {
    return null;
  }

  return (
    <FlexBox className={styles['award-labels__container']}>
      {awards.map((award) => (
        <AwardLabel key={award.feature} award={award} />
      ))}
    </FlexBox>
  );
};
